// CLICKS

const SugarConfig = require("../../sugarconfig");

function goWorkout(swId, tabId) {
    window.document.location = workoutURL(swId, tabId);
}

function workoutURL(swId, tabId) {
    return "/workouts/" + swId + (tabId ? "#" + tabId : "");
}

function goResult(wrId) {
    window.document.location = resultURL(wrId);
}

function resultURL(wrId) {
    return "/workouts/result/" + wrId;
}

function goAthlete(athId, tabId) {
    window.document.location =
        "/athletes/" + athId + (tabId ? "#" + tabId : "");
}

function goAnalysis(dateInt, trackName) {
    window.document.location = analysisURL(dateInt, trackName);
}

function analysisURL(dateInt, trackName) {
    var params = dateInt ? "week=" + dateInt : "";
    params += params.length ? "&" : "";
    params += trackName ? "track=" + encodeURIComponent(trackName) : "";
    return "/workouts/analysis" + (params.length ? "?" : "") + params;
}

function goProgramming(dateInt, trackName) {
    window.document.location = programmingURL(dateInt, trackName);
}

function programmingURL(dateInt, trackName) {
    var params = dateInt ? "week=" + dateInt : "";
    params += params.length ? "&" : "";
    params += trackName ? "track=" + encodeURIComponent(trackName) : "";
    return "/workouts/calendar" + (params.length ? "?" : "") + params;
}

function contactFormParamsForAffiliate(aff) {
    return contactFormParams(
        null,
        aff.athlete.fullName,
        aff.athlete.email,
        aff.name
    );
}

function contactFormParams(
    requestType,
    athleteName,
    athleteEmail,
    gymName,
    requestMessage
) {
    var linkParams = "";
    var delim = "?";
    if (isDefined(requestType)) {
        linkParams += delim + "requestType=" + requestType;
        delim = "&";
    }
    if (isDefined(athleteEmail)) {
        linkParams += delim + "requestorEmail=" + athleteEmail;
        delim = "&";
    }
    if (isDefined(athleteName)) {
        linkParams += delim + "requestorName=" + athleteName;
        delim = "&";
    }
    if (isDefined(gymName)) {
        linkParams += delim + "requestorGymName=" + gymName;
        delim = "&";
    }
    if (isDefined(requestMessage)) {
        linkParams += delim + "requestMessage=" + requestMessage;
        delim = "&";
    }
    return linkParams;
}

function goGymAccount() {
    window.document.location = gymAccountURL();
}

function gymAccountURL() {
    return SugarConfig.paths.gym_ui_prefix + "/account";
}

function goStartTrial() {
    window.document.location = startTrialURL();
}

function startTrialURL() {
    return SugarConfig.domains.app + "/trial";
}

module.exports = {
    goWorkout,
    workoutURL,
    goResult,
    resultURL,
    goAthlete,
    goAnalysis,
    analysisURL,
    goProgramming,
    programmingURL,
    contactFormParamsForAffiliate,
    contactFormParams,
    goGymAccount,
    gymAccountURL,
    goStartTrial,
    startTrialURL,
};
